module.exports = {"TXTWCL_Request_successful":{"id":"TXTWCL_Request_successful","defaultMessage":"ご依頼が処理されました"}}